import { object, string, number, boolean } from "yup";

export default intl => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });
  const notANumber = intl.formatMessage({ id: "app.form.notanumber" });

  return object().shape({
    serial: string(),
    currentFirmware: string(),
    model: string(),
    owner: string(),
    brand: string().required(requiredText),
    deploymentNeeds: string(),
    description: string().required(requiredText),
    type: string().required(requiredText),
    scoreboardPerspective: string().nullable(),
    use: string().required(requiredText),
    publicInterface: object()
      .shape({
        adminTcpPort: number()
          .typeError(notANumber)
          .integer()
          .positive()
          .required(requiredText),
        adminSslPort: number()
          .typeError(notANumber)
          .integer()
          .positive()
          .required(requiredText),
        adminTls: boolean().required(requiredText),
        adminUrl: string(),
        ip: string().required(requiredText),
        streamTcpUrl: string(),
        videoStreamPort: number()
          .typeError(notANumber)
          .integer()
          .positive()
          .required(requiredText),
        protocol: string()
          .required(requiredText)
          .nullable(),
      })
      .required(requiredText),
    users: object()
      .shape({
        admin: object().shape({
          user: string().required(requiredText),
          pass: string().required(requiredText),
        }),
        viewer: object().shape({
          user: string(),
          pass: string(),
        }),
      })
      .required(requiredText),
  });
};
